import React, { useState } from "react";
import PropTypes from "prop-types";
import DatePicker from "../../components/datepicker/ModalDatePicker";
import CommonModal from "./CommonModal";
import Modalstyle from "./modal.module.scss";
import privateAxios from "../../utils/axiosPrivate";
import { showToast } from "../../utils/utils";
import { buttonName, fieldValidation, InvoiceDetails } from "../../locales/en";
import { showToastType } from "../../utils/constants/appConstants";
import { getQuoteFeeAddjustmentsUrl } from "../../utils/constants/apiEndPoints";
import { sanitizeInput } from "../../utils/utils";
import { getFeeAdjusmentData } from "../../redux/invoiceDetailsSlice";
import { useDispatch } from "react-redux";

export const FeeaddModal = ({ isOpen, toggle, quoteID }) => {
  const dispatch = useDispatch();

  const initialFeeAddData = {
    feeCharged: "",
    comment: "",
    completedAt: ""
  };

  const [feeAddData, setFeeAddData] = useState(initialFeeAddData);
  const [errors, setErrors] = useState({});

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const cleanedValue = sanitizeInput(value);

    setFeeAddData((prevState) => ({
      ...prevState,
      [name]: cleanedValue
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleDateChange = (date) => {
    setFeeAddData((prevState) => ({
      ...prevState,
      completedAt: date
    }));
  };

  const validate = () => {
    const tempErrors = {};
    if (!feeAddData.feeCharged)
      tempErrors.feeCharged = fieldValidation?.required;
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      const dataToSend = {
        quoteId: quoteID,
        feeCharged: sanitizeInput(feeAddData.feeCharged),
        comment: sanitizeInput(feeAddData.comment),
        completedAt: feeAddData.completedAt
      };

      const response = await privateAxios.post(
        getQuoteFeeAddjustmentsUrl,
        dataToSend
      );

      if (response.status === 201) {
        await dispatch(getFeeAdjusmentData(quoteID)).unwrap();
        showToast(response.data.message, showToastType.success);
        toggle();
      }
    } catch (error) {
      const errMsg = error.response?.data?.message || error.message;
      showToast(errMsg, showToastType.error);
    }
  };

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={InvoiceDetails?.feeSection?.feeAddModal?.title}
      modalClassName="modal-md"
      bodyClassName="p-3"
      footerButtons={[
        {
          label: buttonName?.close,
          className: "btn btn-secondary",
          onClick: toggle
        },
        {
          label: buttonName?.save,
          className: "btn btn-primary",
          onClick: handleSubmit
        }
      ]}
    >
      <div className="row">
        <div className="mb-3">
          <div className={Modalstyle.modalInputwrap}>
            <label className="form-label">
              {InvoiceDetails?.feeSection?.feeAddModal?.adjustmentAmount}
            </label>
            <div className={Modalstyle.formInput}>
              <input
                type="number"
                name="feeCharged"
                value={feeAddData.feeCharged}
                onChange={handleInputChange}
                placeholder={
                  InvoiceDetails?.feeSection?.feeAddModal?.adjustmentAmount
                }
              />
              {errors.feeCharged && (
                <div className="text-danger small">{errors.feeCharged}</div>
              )}
            </div>
          </div>
        </div>

        <div className="mb-3">
          <div className={Modalstyle.modalInputwrap}>
            <label className="form-label">
              {InvoiceDetails?.feeSection?.feeAddModal?.date}
            </label>
            <div className={Modalstyle.formInput}>
              <DatePicker
                value={feeAddData.completedAt}
                onChange={handleDateChange}
              />
            </div>
          </div>
        </div>

        <div className="mb-3">
          <div className={Modalstyle.modalInputwrap}>
            <label className="form-label">
              {InvoiceDetails?.feeSection?.feeAddModal?.comments}
            </label>
            <div className={Modalstyle.formInput}>
              <textarea
                name="comment"
                value={feeAddData.comment}
                onChange={handleInputChange}
                placeholder={InvoiceDetails?.feeSection?.feeAddModal?.comments}
              />
            </div>
          </div>
        </div>
      </div>
    </CommonModal>
  );
};

FeeaddModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  quoteID: PropTypes.any
};
